import React from 'react';
import { CalendarDays } from 'lucide-react';
import { dayLabel } from './routeDate';

// Alleen-lezen voorbeeld van de eerstvolgende geplande rit.
export const NextRoutePreview = ({ route }) => (
  <div className="bg-white/70 border border-dashed border-zinc-300 rounded-2xl p-4 mt-6" data-testid="driver-next-route">
    <div className="flex items-center gap-2 text-sm font-semibold text-zinc-700">
      <CalendarDays className="w-4 h-4 text-purple-600" />
      Volgende rit: {dayLabel(route.date)} {new Date(`${route.date}T12:00:00`).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })}
    </div>
    <div className="text-xs text-zinc-500 mt-0.5">{route.total_motors} motoren · {route.stop_count} stops · ter info, afvinken kan op die dag</div>
    <ol className="mt-3 space-y-1.5">
      {route.stops.map((s, i) => (
        <li key={`${s.company}-${i}`} className="flex gap-2 text-sm text-zinc-600" data-testid={`driver-next-stop-${i}`}>
          <span className="w-5 h-5 rounded-full bg-zinc-200 text-zinc-700 text-[11px] font-bold flex items-center justify-center shrink-0">{i + 1}</span>
          <span className="min-w-0">
            <span className="font-medium text-zinc-800">{s.company}</span> · {s.motor_count} motor(en)
            <span className="block text-[11px] text-zinc-400 truncate">{s.address || 'Adres ontbreekt'}</span>
          </span>
        </li>
      ))}
    </ol>
  </div>
);
